<form [formGroup]="autoCompleteForm" fxLayout="column">
    <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
        <mat-label>{{ fieldLabel | translate }}</mat-label>
        <input fxLayoutAlign="stretch"
            type="text"
            autocomplete="nope"
            matInput
            formControlName="objDisplay"
            [matAutocomplete]="objAuto">
        <mat-autocomplete 
            #objAuto="matAutocomplete"
            (optionSelected)="setObj($event.option.value)"
            autoSelectOnTab
            autoActiveFirstOption
            [displayWith]="getObjDefinition"
            (optionsScroll)="onObjScroll()">
            <mat-option *ngFor="let obj of filteredObjects" [value]="obj">
                {{ mapMethod(obj).name }}
            </mat-option>
        </mat-autocomplete>
        <mat-error>{{ fieldLabel }} is Required</mat-error>
    </mat-form-field>
</form>